import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import langM from './lang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import moment from "moment"
@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: langM.en,
    language:'en',
    isLoading: true,
    goldRecordList: [],
    goldMore: false,
    goldScroll: null,
    rubyRecordList: null,
    rubyMore: null,
    rubyScroll: null,
    pageindex: true,
    reqUrl:'/web/UserExtendRecordList',
  }

  async componentWillMount() {
    //设置语言 start
    let { language } = this.props.location.query
    setDocumentTitle('Recold with My')
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    console.log('language', language)

    // end
    let uid = await setUidToken(this.props.location.query)
  }

  async onHandleRecord(reqUrl) {
    
    this.setState({
      isLoading: true,
      goldRecordList: [],
      goldMore: false,
      goldScroll: null,
      rubyRecordList: null,
      rubyMore: null,
      rubyScroll: null,
      
    })

    // 代理金币记录列表

    let agentGoldRecordList = await http.post(reqUrl, { scroll: '0,20' })
    this.setState({
      goldRecordList: agentGoldRecordList && agentGoldRecordList.res && agentGoldRecordList.res.list,
      goldMore: agentGoldRecordList.res.hasMore,
      goldScroll: agentGoldRecordList && agentGoldRecordList.res && agentGoldRecordList.res.scroll
    })
    if (!agentGoldRecordList.res.list.length) {
      this.setState({
        pageindex: false
      })
    }
    this.setState({
      recordPopUpState: true
    })
    this.setState({
      isLoading: false
    })
  }
  async componentDidMount() {
    if (this.props.location.query.type == '2') {
      await this.onHandleRecord('/web/agent/recharge/ruby/record')
      this.setState({
        reqUrl:'/web/agent/recharge/ruby/record'
      })
    }else{
      await this.onHandleRecord('/web/UserExtendRecordList')
    }
  }
 
  addMore = async () => {
    let {reqUrl} = this.state
    let { goldMore, goldScroll, goldRecordList } = this.state

    let agentGoldRecordList = await http.post(reqUrl, { scroll: goldScroll })
    this.setState({
      goldRecordList: agentGoldRecordList.res.list && [...goldRecordList, ...agentGoldRecordList.res.list],
      goldMore: agentGoldRecordList && agentGoldRecordList.res && agentGoldRecordList.res.hasMore,
      goldScroll: agentGoldRecordList && agentGoldRecordList.res && agentGoldRecordList.res.scroll
    })
  }
  render() {
    let { lang, goldRecordList, goldScroll, goldMore, pageindex,reqUrl } = this.state
    return (
      <div className={`goldRecold ${!goldRecordList ? 'emp-big' : ''}`}>
        {goldRecordList &&
          goldRecordList.map((item, index) => (
            <div className="list-item" key={index}>
              <div className="list-item-left">
                <div className="left-top">
                  {item.type==0?lang.distribution:item.type==1?lang.recharge:lang.overdraw}: {item.duid}
                </div>
                <div className="left-buttom">{moment(item.ts*1000).format('YYYY-MM-DD HH:mm:ss')}</div>
              </div>
              <div className="list-item-rigth">
                {reqUrl =="/web/UserExtendRecordList" && (<img className="rigth-img" src="/img/app/ruby/icon_coin_gold-new.png"></img>)}
                {reqUrl !="/web/UserExtendRecordList" && (<img className="rigths-img" src="/img/app/ruby/icon_ruby_new.png"></img>)}
                
                <div className="num">{item.gold || item.ruby}</div>
              </div>
            </div>
          ))}
        {goldMore && goldRecordList && (
          <div className="had-more" onClick={this.addMore}>
            {goldMore ? lang.more : lang.noMore}
          </div>
        )}
        {!pageindex && (
          <div className="empty">
            <img className="emp-img" src="/img/app/ruby/img_default_empty.png"></img>
            <div className="emp-text">{lang.empText}</div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/goldRecold/index.js